import { render, staticRenderFns } from "./my-order.vue?vue&type=template&id=4c169dbc&"
import script from "./my-order.vue?vue&type=script&lang=js&"
export * from "./my-order.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports